export default __webpack_public_path__ + "static/button_b.52fc00cff09234c28c2eb4b21f0e9ab5.svg";